import { render, staticRenderFns } from "./HomeInsights.vue?vue&type=template&id=0add91ca&scoped=true"
import script from "./HomeInsights.vue?vue&type=script&lang=js"
export * from "./HomeInsights.vue?vue&type=script&lang=js"
import style0 from "./HomeInsights.vue?vue&type=style&index=0&id=0add91ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0add91ca",
  null
  
)

export default component.exports